import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const SlashCircle02Icon = (props?: SvgProps) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      stroke="#EB4143"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        d="M6 2L2 6M2 2L6 6"
        strokeWidth="0.545455"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
